import { Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

import { AppState } from './store/app.state';
import * as authActions from './auth/store/auth.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'progetto-fe';

  /**
   * Costruttore dell'AppComponent, imposta le lingue disponibili e quella di default
   * @param translate {TranslateService}
   * @param store {Store<AppState>} stato a livello dell'applicazione
   */
  constructor(
    public translate: TranslateService,
    private store: Store<AppState>
  ) {
    translate.addLangs(['en','it']); //definiamo le lingue disponibili
    translate.setDefaultLang('it'); //impostiamo la lingua di default
    // translate.use(translate.getBrowserLang()); //impostiamo come lingua in uso quella del browser
    translate.use('en'); //impostiamo come lingua in uso quella del browser
  }

  /**Metodo dell'interfaccia OnInit, effettua l'autologin in creazione del componente */
  ngOnInit() {
    this.store.dispatch(new authActions.AutoLogin());
  }

}
